import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=0f295d76&scoped=true"
import script from "./NewHome.vue?vue&type=script&lang=js"
export * from "./NewHome.vue?vue&type=script&lang=js"
import style0 from "./NewHome.vue?vue&type=style&index=0&id=0f295d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f295d76",
  null
  
)

export default component.exports